import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function ShieldTick({
  size = sizes.MEDIUM,
  colour = '#E2A60B',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      style={{ width: size, height: size }}
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M16.921 2.36802L9.33622 -0.216797C9.2447 -0.248047 9.12193 -0.263672 8.99916 -0.263672C8.8764 -0.263672 8.75363 -0.248047 8.66211 -0.216797L1.07729 2.36802C0.89202 2.43052 0.740234 2.64481 0.740234 2.84124V13.6091C0.740234 13.8055 0.867467 14.0645 1.02148 14.1872L8.71568 20.1828C8.79381 20.243 8.89425 20.2743 8.99693 20.2743C9.09961 20.2743 9.20229 20.243 9.27818 20.1828L16.9724 14.1872C17.1264 14.0667 17.2536 13.8078 17.2536 13.6091V2.84124C17.2581 2.64481 17.1063 2.43276 16.921 2.36802V2.36802ZM15.6509 13.1805L8.99916 18.3636L2.34738 13.1805V3.63588L8.99916 1.36802L15.6509 3.63588V13.1805ZM6.59291 8.69392C6.52595 8.6024 6.41881 8.5466 6.30273 8.5466H5.07059C4.9255 8.5466 4.84068 8.71177 4.9255 8.83008L7.74693 12.714C7.78029 12.7597 7.82396 12.7968 7.87438 12.8224C7.9248 12.848 7.98056 12.8614 8.03711 12.8614C8.09366 12.8614 8.14941 12.848 8.19984 12.8224C8.25026 12.7968 8.29393 12.7597 8.32729 12.714L13.0728 6.18052C13.1576 6.06222 13.0728 5.89704 12.9277 5.89704H11.6956C11.5818 5.89704 11.4724 5.95285 11.4054 6.04436L8.03711 10.6828L6.59291 8.69392Z"
        fill={colour}
      />
    </svg>
  )
}

ShieldTick.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
